<template>
    <div class="scoring">
        <el-table :data="editData.table" border style="margin-bottom: 20px;">
            <el-table-column width="150" property="type_name" label="打分项" ></el-table-column>
            <el-table-column width="100" property="age_score" label="年龄"></el-table-column>
            <el-table-column width="150" property="degree_score" label="学历">
                <template slot-scope="scope">
                    <div v-html="scope.row.degree_score"></div>
                </template>
            </el-table-column>
            <el-table-column width="150" property="school_score" label="名校背景">
                <template slot-scope="scope">
                    <div v-html="scope.row.school_score"></div>
                </template>
            </el-table-column>
            <el-table-column width="150" property="experience_score" label="工作经验"></el-table-column>
            <el-table-column width="150" property="sea_experience_score" label="海外工作经验"></el-table-column>
            <el-table-column width="150" property="enterprise_score" label="名企加分"></el-table-column>
            <el-table-column width="150" property="talents_score" label="人才清单"></el-table-column>
            <el-table-column width="300" property="language_score" label="语言分">
                <template slot-scope="scope">
                    <div v-html="scope.row.language_score"></div>
                </template>
            </el-table-column>
            <el-table-column width="300" property="background_score" label="家庭背景">
                <template slot-scope="scope">
                    <div v-html="scope.row.background_score"></div>
                </template>
            </el-table-column>
            <el-table-column width="150" property="score" label="总分"></el-table-column>
        </el-table>
        <div class="remarks">
            <div>行业定位：{{ editData.industry }}</div>
            <div style="margin-top: 20px;">
                <div>备注/待确认信息：</div>
                <div style="margin-top: 10px;">
                    <el-input
                        type="textarea"
                        placeholder="请输入"
                        v-model="editData.remark"
                        maxlength="2000"
                        show-word-limit
                    />
                </div>
                <!-- 添加附件 -->
                <AddAnnex
                    :echoFileData="editData.file"
                    @confirm="addAnnexConfirm"
                    @fileClose="fileClose"
                />
            </div>
        </div>
    </div>
</template>

<script>
import AddAnnex from '../../C/AddAnnex.vue'
import { editScoring } from '@/api/schemeReview.js'
    export default {
        components: {
            AddAnnex
        },
        props: {
            // 接收的数据
            editScoringData: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                editData: {},
            }
        },
        mounted () {
            this.editData = this.editScoringData && JSON.parse(JSON.stringify(this.editScoringData))
        },
        methods: {
            // 删除上传的附件
            fileClose(data) {
                this.editData.file.forEach((item, i) => {
                    if (item.fileList[0].fileUrl == data.fileList[0].fileUrl) {
                        this.editData.file.splice(i, 1)
                    }
                });
            },

            // 添加附件确认后回传数据
            addAnnexConfirm (data) {
                this.editData.file = data
            },

            // 保存数据
            async saveInfo () {
                const params = {
                    order_id: this.$route.params.id,
                    ...this.editData,
                }
                const { code } = await editScoring(params)
                if (code == 200) {
                    this.$message({
                        message: '编辑成功',
                        type: 'success'
                    });
                }
            }
        },
    }
</script>

<style lang="less" scoped>
.scoring{
    a{
    color: #409eff;
    font-size: 12px;
    margin-right: 20px;
}
    .remarks{
        >div{
            margin-bottom: 20px;
        }
    }
}
</style>
